export enum TabSize {
  Medium,
  Small,
  ExtraSmall,
  Smallest,
}
